function add_focus_behavior_input() {
    // get all loaded bordered-input-components
    document.querySelectorAll('.cu-input').forEach(container => {
        // ..get input, label, top_border, right_border, bottom_border, left_border
        let input_query = container.querySelectorAll('input, select, textarea');

        if (input_query.length === 0) {
            return;
        }



        let input = input_query.length > 1 ? input_query[1] : input_query[0];
        let label = container.children[0].children[1].children[0].children[0].children[0];
        let border_top = container.children[0].children[1].children[0].children[1];
        let border_right = container.children[0].children[2];
        let border_bottom = container.children[0].children[1].children[2];
        let border_left = container.children[0].children[0];

        if (container.classList.contains('bordered-input-disabled')) {
            input.disabled = true;
        } else {
            // label.classList.add('tw-font-bold');
            // input.classList.add('tw-h-4');
            // ..add focus-, blur-events to inputs
            input.onfocus = function() {
                // label.classList.add('tw-text-black');
                border_top.classList.add('tw-border-brand-primary');
                border_right.classList.add('tw-border-brand-primary');
                border_bottom.classList.add('tw-border-brand-primary');
                border_left.classList.add('tw-border-brand-primary');

                border_top.classList.remove('tw-border-border-input');
                border_right.classList.remove('tw-border-border-input');
                border_bottom.classList.remove('tw-border-border-input');
                border_left.classList.remove('tw-border-border-input');
            }
            input.onblur = function() {
                // label.classList.remove('tw-text-black');
                border_top.classList.remove('tw-border-brand-primary');
                border_right.classList.remove('tw-border-brand-primary');
                border_bottom.classList.remove('tw-border-brand-primary');
                border_left.classList.remove('tw-border-brand-primary');

                border_top.classList.add('tw-border-border-input');
                border_right.classList.add('tw-border-border-input');
                border_bottom.classList.add('tw-border-border-input');
                border_left.classList.add('tw-border-border-input');
            }
        }
    });
}

function more_inputs_loaded() {
    add_focus_behavior_input();
}

add_focus_behavior_input();

window.add_focus_behavior_input = add_focus_behavior_input;
window.more_inputs_loaded = more_inputs_loaded;